import {
	callbackify
} from "util";
import Api from '@/services/api.js';
import Log from "@/services/log.js";
import vSelect from 'vue-select';
import vTributos from "@/components/v-tributos/v-tributos.vue";
import InputMensagemErro from "@/components/input-mensagem-erro.vue";

var $ = require("jquery");
var elemento = '';
export default {
	props: [
		'empresa'
	],
	components: {
		InputMensagemErro
	},
  inject: ["pushAlert"],
	data() {
		return {
			msg: 'Olá Mundo!',
			blLoadInicial: true,
			procedures: [],
			chamada_procedure: '',
			numero_card: '',
			alertas: [],
			blLoadingSalvar: false,
			blSalvar: false,
			blTestar: false,
			blAtualizar: false,
			blRemover: false,
			blTraducao: false,
			resultadoDiferente: '',
			resultadoSalvo: '',
			resultadoTraducao: '',
		}
	},
	created: function() {

	},
	mounted: function() {
		this.listarTestes();
	},
	computed: {

	},
	watch: {

	},
	methods: {

		mostra_mensagem: function(mensagem) {
			$('.mensagem_limite').html(mensagem);
			$('.mensagem_limite').fadeIn('fast');
		},

		resetFields: function() {
			this.chamada_procedure = "";
			this.numero_card = "";
		},

		listarTestes: function() {
			let that = this;
			new Api().get('TesteAutomatizado/listarTestes').then(response => {
				that.blLoadingSalvar = false;
				that.procedures = response.dados;
				that.blLoadInicial = false;
			});
		},

		onClickSalvar: function() {
			if (this.chamada_procedure == '' || this.chamada_procedure == null) {
				return false;
			}
			this.blSalvar = true;
			let obj = {};
			let textNome = '';
			let that = this;
			let teste = {
				chamada_procedure: this.chamada_procedure,
				numero_card: this.numero_card,
				id_usuario: localStorage.getItem("id_original")
			};

			this.blLoadingSalvar = true;
			new Api().post('TesteAutomatizado/salvarTeste', teste).then(response => {
				that.blLoadingSalvar = false;
				that.resetFields();

				that.alertas = [];
				that.alertas.push({
					msg: 'Cadastrado com sucesso',
					class: 'success',
					blShow: true
				});

				that.listarTestes();
				that.blSalvar = false;
			});
		},

		onClickTestar: function(id = null) {
			let that = this;
			let url = "";
			let newProcedures = [];
			this.blTestar = true;

			if (id != null) {
				url = 'TesteAutomatizado/realizarTeste/' + id;
			} else {
				url = 'TesteAutomatizado/realizarTestes';
			}

			new Api().get(url).then(response => {

				that.alertas = [];
				that.alertas.push({
					msg: 'Testado com sucesso',
					class: 'success',
					blShow: true
				});

				if (id != null) {
					that.procedures.forEach(element => {
						if (element.id_teste_automatizado == response.dados.id_teste_automatizado) {
							newProcedures.push(response.dados);
						} else {
							newProcedures.push(element);
						}
					});
					that.procedures = newProcedures;
				} else {
					that.procedures = response.dados;
				}

				that.blTestar = false;
			});

		},

		onClickAtualizar: function(id) {
			this.blAtualizar = true;
			this.requestDefault('Atualizar', 'TesteAutomatizado/atualizarTeste/' + id);
		},

		onClickRemover: function(id) {
			this.blRemover = true;
			this.requestDefault('Remover', 'TesteAutomatizado/removerTeste/' + id);
		},

		requestDefault: function(origem, url) {
			let that = this;

			new Api().get(url).then(response => {

				that.alertas = [];
				that.alertas.push({
					msg: 'OK',
					class: 'success',
					blShow: true
				});

				that.listarTestes();

				if (origem == 'Atualizar') {
					that.blAtualizar = false;
				} else if (origem == 'Remover') {
					that.blRemover = false;
				}
			});
		},

		openModalResultado: function(mensagem, resultado) {
			this.resultadoDiferente = mensagem;
			this.resultadoSalvo = resultado;
			this.$refs.modalResultado.show();
		},

		closeModalResultado: function() {
			this.$refs.modalResultado.hide();
		},

		openModalTraducao: function(call) {
			let that = this;
			let json = "{'proc': '" + call + "'}";
			let texto = '';
			this.blTraducao = true;
			this.$refs.modalTraducao.show();
			new Api().post('Tools/traduzCenarioProc', {
				'proc': call
			}).then(response => {
				if (response != 'undefined' && response != null && response != '') {
					[response].forEach(element => {
						texto += '<p>' + element + '</p>';
					});
				}
				that.resultadoTraducao = texto;
				that.blTraducao = false;
			});
		},

		closeModalTraducao: function() {
			this.$refs.modalTraducao.hide();
		}

	}
}